import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { amlbotAPI } from '@/api';
import type {
  GetServiceOptionsRequest,
  GetServiceOptionsResponse,
} from '@/api';
import { serviceOptionsActions } from '../../actions';
import { serviceOptionsMappers } from '../../mappers';

function* fetchOptions(
  action: PayloadAction<GetServiceOptionsRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: GetServiceOptionsResponse = yield call(
      amlbotAPI.fetchServiceOptions,
      payload,
    );
    const data = serviceOptionsMappers.fetchOptions(response);
    yield put(serviceOptionsActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(serviceOptionsActions.setLoading(false));
  }
}

export { fetchOptions };
